import webSite from '../img/developer_w1280.jpg'
import host from '../img/cloud_w1280.jpg'
import seoImg from '../img/seo_w1280.jpg';
import adminImg from '../img/admin_w1280.jpg';
import designImg from '../img/design_w1280.jpg';

export const servicesList = [
    {
        img: webSite,
        imgAlt: "Komputer z otwrtym edytorem do tworzenia stron www",
        title: "Strony internetowe",
        subTitle: "Każda strona jest jak nowa przygoda",
        services: [
            "Specjalizuję się w tworzeniu stron internetowych, opierając się na najwyższych standardach i nowoczesnych technologiach.",
            `Podejście "mobile first" gwarantuje doskonałą widoczność na wszystkich urządzeniach, co pozwala Twoim klientom łatwo dotrzeć do Twojej oferty.`,
            "Optymalizuję strony pod kątem szybkości, co zwiększa satysfakcję użytkowników i wpływa na lepsze pozycjonowanie w wyszukiwarkach.",
        ]
    },

    {
        img: host,
        imgAlt: "Chmura symbolizująca chmurę jako przestrzeń na dane w sieci",
        title: "Rozwiązania hostingowe",
        subTitle: "Bezpieczne schronienie dla Twojej strony",
        services: [
            "Doradzam w wyborze i rejestracji domeny, aby znaleźć idealną nazwę dla Twojej marki.",
            "Pomagam w doborze odpowiedniego hostingu dopasowanego do Twoich potrzeb.",
            "Instaluję protokół SSL, zapewniając wyższy poziom bezpieczeństwa Twojej strony.",
            "Zajmuję się umieszczaniem treści na serwerze i pełną konfiguracją witryny."
        ]
    },

    {
        img: seoImg,
        imgAlt: "Grafika z napisem seo, czyli skrót od Search Engine Optimization",
        title: "Optymalizacja SEO",
        subTitle: "Pozycjonowanie to inwestycja w sukces Twojej strony",
        services: [
            "Tworzę strony internetowe przyjazne wyszukiwarkom, co zwiększa ich widoczność.",
            "Stosuję najwyższe standardy i odpowiednie znaczniki semantyczne, aby poprawić indeksację.",
            "Dobieram właściwe słowa kluczowe, które przyciągną uwagę klientów.",
            "Optymalizuję szybkość działania strony, co zwiększa satysfakcję użytkowników."

        ]
    },

    {
        img: adminImg,
        imgAlt: "Pulpit z logowaniem dla administratora",
        title: "Administracja strony",
        subTitle: "Utrzymuj swoją stronę w dobrej formie",
        services: [
            "Zapewniam pełną administrację strony internetowej",
            "Kontrolę nad funkcjonowaniem witryny, aby uniknąć przestojów i problemów z dostępnością.",
            "Wprowadzanie niezbędnych poprawek oraz modernizację treści, by strona zawsze wyglądała atrakcyjnie.",
            "Aktualizację wtyczek CMS, co zapewnia bezpieczeństwo i optymalną wydajność strony."
        ]
    },

    {
        img: designImg,
        imgAlt: "Grafika z napisem design",
        title: "Web Design",
        subTitle: "Zaprojektuj swój wirtualny świat",
        services: [
            "Tworzenie mockupów stron www zgodnych z najnowszymi standardami UX/UI, co zapewnia intuicyjność nawigacji",
            "Projektowanie logotypów i grafik, które skutecznie oddają charakter i wartości Twojej marki",
        ]
    },
]